'use client'

import { QUERY_ROUTES } from '@/core/constants/routes'
import { useDeleteSearchParam } from '@/core/hooks/use-delete-search-params'
import { updateHistoryState } from '@/core/lib/utils/routing'
import { Modal, ModalBody } from '@/core/ui/atoms/modal'
import { usePathname } from 'next/navigation'
import { useCallback } from 'react'
import { ForgotPasswordForm } from './forgot-password'

export const ForgotPasswordModal = () => {
  const { searchParams, deleteSearchParam } = useDeleteSearchParam()
  const pathname = usePathname()

  const handleClose = useCallback(() => {
    deleteSearchParam(QUERY_ROUTES.forgotPassword.name, { clientOnly: true })
  }, [deleteSearchParam])

  const handleSuccess = useCallback(() => {
    const params = new URLSearchParams(searchParams)
    params.set(
      QUERY_ROUTES.resetPassword.name,
      QUERY_ROUTES.resetPassword.value,
    )
    updateHistoryState(`${pathname}?${params.toString()}`, { type: 'replace' })
  }, [pathname, searchParams])

  return (
    <>
      <Modal
        isOpen={
          QUERY_ROUTES.forgotPassword.value ===
          searchParams.get(QUERY_ROUTES.forgotPassword.name)
        }
        disableBackdropDismiss
        onClose={handleClose}
        size='md'
        className='max-h-[90%] max-w-lg overflow-y-hidden rounded-2xl sm:max-h-full'
      >
        <ModalBody className='p-4'>
          <ForgotPasswordForm onSuccess={handleSuccess} />
        </ModalBody>
      </Modal>
    </>
  )
}
